export default __webpack_public_path__ + "static/media/happy.45ebdfe2.png";